import type { FC } from "react";
import { useDrop } from "react-dnd";

export const ServiceContractCreateAssignedFields: FC<any> =
  function ServiceContractCreateAssignedFields({
    accept,
    heading,
    serviceContractValues,
    editContract,
    iterateField,
    onDrop,
    onRemove,
    showStaticFields = false
  }) {
    const [, drop] = useDrop({
      accept,
      drop: onDrop,
    });

    const staticFields = ['Pay Item', 'Activity', 'UOM', 'Unit Hours', 'Unit Amount'];

    return (
      <div ref={drop} data-testid="dustbin" className="addition-right">
        <div className="al-heading">
          <h6 className="m-0">{heading}</h6>
        </div>
        <div className={`al-body ${editContract ? "is-disabled" : ""}`}>
          <div className="add-tag-content">
            {showStaticFields && staticFields.map(
              (field: any, index: number) => (
                <span className={`add-tag ${!editContract ? "is-disabled" : ""}`} key={index}>
                  {field}
                </span>
              )
            )}
            {serviceContractValues[iterateField]?.map(
              (field: any, index: number) => (
                <span className="add-tag" key={index}>
                  {field.fieldName}
                  <i
                    className="icon-remove"
                    onClick={(e) => {
                      onRemove({ field });
                    }}
                  ></i>
                </span>
              )
            )}
            {serviceContractValues[iterateField].length === 0 ? (
              <span className="d-block w-100 text-center">
                Please try adding from Available Fields
              </span>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    );
  };
